const indexItems = [
  { id: 1, label: '动作片', icon: 'ri-fire-line', count: '1,286部' },
  { id: 2, label: '喜剧片', icon: 'ri-emotion-happy-line', count: '892部' },
  { id: 3, label: '爱情片', icon: 'ri-heart-line', count: '1,054部' },
  { id: 4, label: '科幻片', icon: 'ri-rocket-line', count: '743部' },
  { id: 5, label: '悬疑片', icon: 'ri-search-eye-line', count: '621部' },
  { id: 6, label: '国产剧', icon: 'ri-china-railway-line', count: '2,310部' },
  { id: 7, label: '韩剧', icon: 'ri-kakao-talk-line', count: '1,478部' },
  { id: 8, label: '综艺', icon: 'ri-tv-line', count: '956部' },
  { id: 9, label: '纪录片', icon: 'ri-earth-line', count: '534部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            影视索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            按分类快速查找你感兴趣的影视内容，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {indexItems.slice(0, 5).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200/50 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-lg text-primary-500 group-hover:text-white w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
          {indexItems.slice(5).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-accent-200/50 hover:bg-accent-50/30 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-500 transition-colors">
                <i className={`${item.icon} text-lg text-accent-600 group-hover:text-white w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}